import { AppAssessments } from "../data_objects/app_assessments";

export enum ViewAssessmentsOptions {
  SPEAKING = "SPEAKING",
  MCQS = "MCQS",
  WRITING = "WRITING",
  READING_QUESTIONS = "READING_QUESTIONS",
  LISTENING_QUESTIONS = "LISTENING_QUESTIONS",
  GRAMMAR = "GRAMMAR"
}

export enum CandidateAiAssessmentsViewOptions {
  MULTIPLE_CHOICE = "mcq",
  SHORT_ANSWER = "short_answer",
  TRUE_FALSE = "true_false"
}

export enum AssessmentResultStatus {
  RESULT_PROCESSING = "RESULT_PROCESSING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  FAILED = "FAILED",
  REDO = "REDO"
}

export enum CandidateAssessmentsViewOptions {
  speaking,
  writing
}

export interface AppAnnotation2Answers {
  content: string;
  options: AppAnnotation2Options[];
}
export interface AppEnglish3McqsAnswers {
  question: string;
  question_index: number;
  answer: string;
  result: boolean;
}

export interface AppAnnotation2Options
  extends AppAssessments.QuestionResponsesOptions {
  op1_selected: boolean;
  op2_selected: boolean;
}

export interface AppAnnotation3Answers {
  content: string;
  arabic: string;
  answer: string;
}

export interface AppAnnotation4Answers {
  content: string;
  title: string;
  answer: string;
}

export interface AppAnnotation5Answers {
  question: string;
  answer: string;
}
export interface AppAnnotation8Answers {
  audio_url: string;
  answer: string;
}
export interface AppAnnotation7Answers {
  question: string;
  answer: string;
  correct_answer: string;
  score: number;
}
export interface AppAnnotation6Answers {
  question: string;
  answer: string;
  correct_answer?: string;
  error?: string;
}

// New API Response Interfaces
export interface AssessmentApiResponse {
  success: boolean;
  message: string;
  data: AssessmentData;
}

export interface AssessmentData {
  applicant: Applicant;
  assessment: Assessment;
  questions: AssessmentQuestion[];
  results: AssessmentResult[];
}

export interface Applicant {
  id: string;
  name: string;
  email: string;
  type: string;
}

export interface Assessment {
  id: number;
  name: string;
  type: string;
  difficulty: string;
  is_active: boolean;
  total_questions: number;
}

export interface AssessmentQuestion {
  id: number;
  assessment_id: number;
  question_type: CandidateAiAssessmentsViewOptions;
  question_text: string;
  question_options: string[];
  question_time_allowed: number;
  is_question_enable: boolean;
  is_completed?: boolean; // Added for tracking completion status
  answer?: any; // Added for pre-populating answers
  created_by: number;
  user_id: number | null;
  job_id: number | null;
}

export interface AssessmentResult {
  id: number;
  assessment_id: number;
  user_id: number;
  overall_score: number | null;
  total_questions: number | null;
  current_question: number | null;
  status: AssessmentResultStatus;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  result_data: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  urls: any;
  completed_at: string;
  resume_admin_status?: "PENDING" | "APPROVED" | "REJECTED" | null;
}
